import { Button } from "@/components/ui/button";
import { components } from "@/lib/openapi";
import { updateRule } from "@/queries/playlists";
import { Pencil } from "lucide-react";
import { useState } from "react";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { useToast } from "@/components/ui/use-toast";
import { useQueryClient } from "@tanstack/react-query";
import { RuleForm } from "./RuleForm";

type Rule = components["schemas"]["RuleSchema"];

export function UpdateRuleDialog({ rule }: { rule: Rule }) {
  const [isOpen, setIsOpen] = useState(false);
  const { toast } = useToast();
  const queryClient = useQueryClient();
  const updateMutation = updateRule(rule.id);

  const handleSuccess = () => {
    queryClient.invalidateQueries({ queryKey: ["rules"] });
    toast({
      title: "Success",
      description: "Rule updated successfully",
    });
    setIsOpen(false);
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" size="icon">
          <Pencil className="h-4 w-4" />
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Edit Rule</DialogTitle>
          <DialogDescription>
            Update the rule settings and conditions.
          </DialogDescription>
        </DialogHeader>
        <RuleForm
          mode="edit"
          rule={rule}
          onSuccess={handleSuccess}
          mutation={updateMutation}
        />
      </DialogContent>
    </Dialog>
  );
}
